export const languages = {
    cn: {
        // eventViewer
        "eventViewer.filterPlaceholder": "事件类型过滤",
        "eventViewer.normalMode": "正常模式",
        "eventViewer.darkMode": "暗黑模式",
        "eventViewer.showEvent": "显示事件",
        "eventViewer.showListeners": "显示注册的监听器",
        "eventViewer.totalLogs": "共{0}条",
        "eventViewer.hideListenerDetails": "隐藏监听器详情",
        "eventViewer.showListenerDetails": "显示监听器详情",
        "eventViewer.clear": "清空",
        "eventViewer.extendedFlags": "扩展标识",
        "eventViewer.transformed": "经过转换",
        "eventViewer.serialNumber": "序号",
        "eventViewer.totalListeners": "共{0}个监听器",
        "eventViewer.retainLastEvent": "保留最后一次事件数据",
        "eventViewer.rawEventType": "原始事件类型: {0}",
        "eventViewer.executionTime": "执行耗时",
        "eventViewer.copyMessage": "复制事件消息",
        "eventViewer.triggerTime": "触发时间",
        "eventViewer.eventType": "事件类型",
        "eventViewer.listenerTag": "监听器标签: {0}",
        "eventViewer.executionCount": "执行次数计数（当前/总数）",
        "eventViewer.listenerFlags": "监听器标识flags",
        "eventViewer.executing": "执行中...",
        "eventViewer.error": "错误: {0}",
        "eventViewer.noEventLogs": "暂无事件日志",
        "eventViewer.listener": "监听器: {0}",
        "eventViewer.executionResult": "执行结果：",
        "eventViewer.switchEmitter": "切换 Emitter",
        "eventViewer.inspect": "注册实例到控制台：{}",
        // listenerViewer
        "listenerViewer.registeredListeners": "已注册监听器",
        "listenerViewer.refresh": "刷新",
        "listenerViewer.noRegisteredListeners": "暂无注册的监听器",
        "listenerViewer.nodeHasNoListeners": "该节点暂无监听器",
        "listenerViewer.listener": "监听器: {0}",
        "listenerViewer.executionCount": "执行次数: {0}/{1}",
        "listenerViewer.tag": "标签: {0}",
        "listenerViewer.flags": "标识: {0}",
        "listenerViewer.retainedMessage": "保留消息",
        // listenerCard
        "listenerCard.invalidData": "监听器数据无效",
        "listenerCard.listenerFunction": "监听函数",
        "listenerCard.executionCount": "执行次数",
        "listenerCard.tag": "标签",
        "listenerCard.flags": "标识",
        "listenerCard.returnValue": "返回值",
        "listenerCard.clickToConsole": "点击在控制台输出监听器信息",
        "listenerCard.clickToConsoleResult": "单击显示在控制台",
        "listenerCard.anonymous": "anonymous",
    },
    en: {
        // eventViewer
        "eventViewer.filterPlaceholder": "Filter by event type",
        "eventViewer.normalMode": "Normal mode",
        "eventViewer.darkMode": "Dark mode",
        "eventViewer.showEvent": "Show events",
        "eventViewer.showListeners": "Show registered listeners",
        "eventViewer.totalLogs": "Total {0}",
        "eventViewer.hideListenerDetails": "Hide listener details",
        "eventViewer.showListenerDetails": "Show listener details",
        "eventViewer.clear": "Clear",
        "eventViewer.extendedFlags": "Extended flags",
        "eventViewer.transformed": "Transformed",
        "eventViewer.serialNumber": "Serial number",
        "eventViewer.totalListeners": "{0} listeners",
        "eventViewer.retainLastEvent": "Retain last event data",
        "eventViewer.rawEventType": "Raw event type: {0}",
        "eventViewer.executionTime": "Execution time",
        "eventViewer.copyMessage": "Copy event message",
        "eventViewer.triggerTime": "Trigger time",
        "eventViewer.eventType": "Event type",
        "eventViewer.listenerTag": "Listener tag: {0}",
        "eventViewer.executionCount": "Execution count (current/total)",
        "eventViewer.listenerFlags": "Listener flags",
        "eventViewer.executing": "Executing...",
        "eventViewer.error": "Error: {0}",
        "eventViewer.noEventLogs": "No event logs",
        "eventViewer.listener": "Listener: {0}",
        "eventViewer.executionResult": "Execution result:",
        "eventViewer.switchEmitter": "Switch Emitter",
        "eventViewer.inspect": "Inject to console: {}",
        // listenerViewer
        "listenerViewer.registeredListeners": "Registered Listeners",
        "listenerViewer.refresh": "Refresh",
        "listenerViewer.noRegisteredListeners": "No registered listeners",
        "listenerViewer.nodeHasNoListeners": "This node has no listeners",
        "listenerViewer.listener": "Listener: {0}",
        "listenerViewer.executionCount": "Execution count: {0}/{1}",
        "listenerViewer.tag": "Tag: {0}",
        "listenerViewer.flags": "Flags: {0}",
        "listenerViewer.retainedMessage": "Retained Message",
        // listenerCard
        "listenerCard.invalidData": "Invalid listener data",
        "listenerCard.listenerFunction": "Listener function",
        "listenerCard.executionCount": "Execution count",
        "listenerCard.tag": "Tag",
        "listenerCard.flags": "Flags",
        "listenerCard.returnValue": "Return value",
        "listenerCard.clickToConsole": "Click to output listener info to console",
        "listenerCard.clickToConsoleResult": "Click to show in console",
        "listenerCard.anonymous": "anonymous",
    },
};
